import { render } from "./MainWrapper.vue?vue&type=template&id=5c53b476"
import script from "./MainWrapper.vue?vue&type=script&lang=js"
export * from "./MainWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__